import {
  Button,
  FormControlLabel,
  IconButton,
  Modal,
  Paper,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import { Settings } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { useUIStore } from "../../views/assistant/stores/UIStore";

const DeveloperToolbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  // Only show in development mode
  if (process.env.NODE_ENV === "production") {
    return null;
  }

  const handleDirectToolsClick = () => {
    history.push("/assistant/direct-tools");
    setIsOpen(false);
  };

  return (
    <>
      <Tooltip title="Developer Tools">
        <IconButton
          onClick={() => setIsOpen(true)}
          size="small"
          aria-label="Developer tools"
          sx={{ color: "#ff9800" }}
        >
          <Settings />
        </IconButton>
      </Tooltip>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="developer-toolbar-modal"
        aria-describedby="developer-toolbar-modal-description"
      >
        <Paper
          elevation={4}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Stack spacing={2}>
            <Typography
              id="developer-toolbar-modal"
              variant="h6"
              component="h2"
            >
              Developer Tools
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={useUIStore((s) => s.preferences.disableRehype)}
                  onChange={(e) =>
                    useUIStore.getState().setPreferences({
                      disableRehype: e.target.checked,
                    })
                  }
                />
              }
              label="Disable Rehype"
            />
            <Button
              variant="contained"
              onClick={handleDirectToolsClick}
              fullWidth
            >
              Direct Tools
            </Button>
          </Stack>
        </Paper>
      </Modal>
    </>
  );
};

export default DeveloperToolbar;
